// import React, { useEffect, useMemo } from "react";
// import "../Home/Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
// import { IoIosArrowForward } from "react-icons/io";
// import { services, Blogs_data } from "../../Config";
// import { useParams } from "react-router-dom";

// const OurServices = () => {
//   console.log("OurServices rendered");

//   const { serviceLink } = useParams();

//   // ✅ Stable memoized lookup
//   const selectedService = useMemo(
//     () => services.find((service) => service.serviceLink === serviceLink),
//     [serviceLink]
//   );

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   if (!selectedService) {
//     return (
//       <div className="flex items-center justify-center h-screen text-xl">
//         Loading service details...
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
//       <Header />

//       {/* Banner */}
//       <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-32">
//         <div className="card_titleBanner relative w-full pt-14 pb-12 group rounded-lg overflow-hidden flex flex-col bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold">
//           <div className="flex flex-col sm:items-center">
//             <p className="font-semibold uppercase text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
//               {selectedService.title}
//               <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
//             </p>
//             <p className="flex items-center gap-1 mt-3 text-sm">
//               Home <IoIosArrowForward /> Our Services
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="px-5 lg:px-[10%] 2xl:px-[15%] pb-10">
//         <div className="space-y-6">
//           {[...Array(5)].map((_, i) => {
//             const content = selectedService[`content${i + 1}`];
//             return content ? <p key={i}>{content}</p> : null;
//           })}

//           <div className="space-y-4">
//             {[...Array(5)].map((_, i) => {
//               const bullet = selectedService[`bullet${i + 1}`];
//               return bullet ? (
//                 <p key={i}>
//                   <span className="text-teal-500">⦿&nbsp;</span>
//                   {bullet}
//                 </p>
//               ) : null;
//             })}
//           </div>
//         </div>

//         {/* Related Blogs Section */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-x-8 gap-y-16 mt-16">
//           {Blogs_data.map((blog, index) => (
//             <a
//               key={index}
//               href={blog.href}
//               className="group bg-white dark:bg-[#252525] p-2 shadow-md hover:shadow-custom dark:hover:shadow-white rounded-lg flex flex-col transition-all duration-300"
//             >
//               <img
//                 src={blog.imgSrc}
//                 alt={blog.title}
//                 className="w-full aspect-[5/4] object-center object-cover rounded-t-md -mt-8 group-hover:-translate-y-2 transition-all duration-300 ease-in-out"
//                 loading="lazy"
//               />
//               <div className="p-1 mt-3">
//                 <p className="font-medium text-base 2xl:text-lg">
//                   {blog.title}
//                 </p>
//                 <p className="text-sm 2xl:text-xl mt-6">{blog.author}</p>
//                 <p className="text-[12px] 2xl:text-lg font-light mt-1">
//                   {`${blog.date} ∙ ${blog.readTime}`}
//                 </p>
//               </div>
//             </a>
//           ))}
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default OurServices;

import React, { useEffect } from "react";
import "../Home/Home.css";
import { motion as m } from "framer-motion";
import { IoIosArrowForward } from "react-icons/io";
import { All_Projects, services } from "../../Config";
import { useParams } from "react-router-dom";

const OurServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { serviceLink } = useParams();

  const selectedService = services.find(
    (service) => service.serviceLink === serviceLink
  );

  const filteredProjects = All_Projects.filter(
    (project) =>
      Array.isArray(project.services) &&
      project.services.includes(selectedService?.title)
  );

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-32">
          <div className="card_titleBanner relative w-full pt-14 pb-12 group rounded-lg overflow-hidden flex flex-col bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold transition-all duration-300 ease-in-out">
            <div className="flex flex-col sm:items-center">
              <p className="font-semibold uppercase text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                {selectedService.title}
                <span className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </p>

              <p className="flex items-center gap-1 mt-3 text-sm">
                Home <IoIosArrowForward className="text-teal-600" />
                Our Services <IoIosArrowForward className="text-teal-600" />
                <i>{selectedService.title} </i>
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pb-10">
          <div className="space-y-6">
            {selectedService.content1 && <p>{selectedService.content1}</p>}

            {selectedService.content2 && <p>{selectedService.content2}</p>}

            {selectedService.content3 && <p>{selectedService.content3}</p>}

            {selectedService.content4 && <p>{selectedService.content4}</p>}

            <div className="space-y-4">
              {selectedService.bullet1 && (
                <p>
                  <span className="text-teal-500">⦿&nbsp;</span>
                  {selectedService.bullet1}
                </p>
              )}

              {selectedService.bullet2 && (
                <p>
                  <span className="text-teal-500">⦿&nbsp;</span>
                  {selectedService.bullet2}
                </p>
              )}

              {selectedService.bullet3 && (
                <p>
                  <span className="text-teal-500">⦿&nbsp;</span>
                  {selectedService.bullet3}
                </p>
              )}

              {selectedService.bullet4 && (
                <p>
                  <span className="text-teal-500">⦿&nbsp;</span>
                  {selectedService.bullet4}
                </p>
              )}

              {selectedService.bullet5 && (
                <p>
                  <span className="text-teal-500">⦿&nbsp;</span>
                  {selectedService.bullet5}
                </p>
              )}
            </div>

            {selectedService.content5 && <p>{selectedService.content5}</p>}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-8 xl:gap-12 mt-10">
            {filteredProjects.length > 0 ? (
              filteredProjects.map((project, index) => (
                <div key={index} href={project.href}>
                  <div className="relative bg-white dark:bg-[#252525] shadow-newcustom rounded-lg px-3 group overflow-hidden transition-all duration-300 ease-in-out">
                    {/* Light Logo */}
                    <img
                      src={project.logo}
                      alt="project-logo"
                      loading="lazy"
                      className="aspect-[1/1] object-contain dark:hidden group-hover:scale-90 transition-all duration-500 ease-in-out"
                    />

                    {/* Dark Logo */}
                    <img
                      src={project.white_logo}
                      alt="project-logo-dark"
                      loading="lazy"
                      className="aspect-[1/1] object-contain hidden dark:block group-hover:scale-90 transition-all duration-500 ease-in-out"
                    />

                    {/* Gradient overlay (only on hover) */}
                    <div className="absolute inset-0 bg-gradient-to-br from-black/10 dark:from-white/40 via-black/0 dark:via-white/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out rounded-lg">
                      <p className="absolute top-3 left-3 dark:text-white text-sm font-medium">
                        {project.name}
                      </p>
                    </div>

                    {/* View More button at bottom center */}

                    {project.caseStudyLink === "coming-soon" ? (
                      <div className="absolute bottom-[-2rem] right-4 opacity-0 group-hover:bottom-4 group-hover:opacity-100 transition-all duration-500 ease-in-out flex flex-col text-sm">
                        Coming soon
                        <div className="h-0.5 w-14 -ml-3 bg-white dark:bg-black transition-all duration-500 delay-200 ease-in-out group-hover:bg-gray-400"></div>
                      </div>
                    ) : (
                      <a
                        href={`/project-case-study/${project.caseStudyLink}`}
                        target="_blank"
                        rel="noreferrer"
                        className="absolute bottom-[-2rem] right-4 opacity-0 group-hover:bottom-4 group-hover:opacity-100 transition-all duration-500 ease-in-out flex flex-col text-sm"
                      >
                        View more
                        <div className="h-0.5 w-14 -ml-3 bg-white dark:bg-black transition-all duration-500 delay-200 ease-in-out group-hover:ml-1.5 group-hover:bg-teal-500"></div>
                      </a>
                    )}

                    {/* <a
                      href={`/project-case-study/${project.caseStudyLink}`}
                      className="absolute bottom-[-2rem] right-4 opacity-0 group-hover:bottom-4 group-hover:opacity-100 transition-all duration-500 ease-in-out flex flex-col text-sm"
                    >
                      View more
                      <div className="h-0.5 w-14 -ml-3 bg-white dark:bg-black transition-all duration-500 delay-200 ease-in-out group-hover:ml-1.5 group-hover:bg-teal-500"></div>
                    </a> */}
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500 col-span-full">
                No projects available under this service yet.
              </p>
            )}
          </div>

          <hr className="mt-16 mb-5 border-t border-teal-500 dark:border-teal-600" />

          <div className="text-sm">
            <div className="flex items-center -ml-[6px]">
              <div className="h-[3px] w-4 bg-teal-600 rotate-90 rounded-t-sm" />

              <p className="font-medium uppercase">Other Services</p>
            </div>

            <div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-x-5 gap-y-3 mt-4">
              <a
                href="/services/website-designing-and-development"
                className="font-normal text-gray-400 hover:text-teal-600"
              >
                Website Designing & Development
              </a>

              <a
                href="/services/e-commerce-development"
                className="font-normal text-gray-400 hover:text-teal-600"
              >
                E-Commerce Development
              </a>

              <a
                href="/services/software-development"
                className="font-normal text-gray-400 hover:text-teal-600"
              >
                Software Development
              </a>

              <a
                href="/services/mobile-app-development"
                className="font-normal text-gray-400 hover:text-teal-600"
              >
                Mobile App Development
              </a>

              <a
                href="/services/written-production"
                className="font-normal text-gray-400 hover:text-teal-600"
              >
                Written Production
              </a>

              <a
                href="/services/management-services"
                className="font-normal text-gray-400 hover:text-teal-600"
              >
                Management Services
              </a>

              <a
                href="/services/wordpress"
                className="font-normal text-gray-400 hover:text-teal-600"
              >
                WordPress
              </a>

              <a
                href="/services/seo"
                className="font-normal text-gray-400 hover:text-teal-600"
              >
                SEO
              </a>
            </div>
          </div>
        </div>
      </div>
    </m.div>
  );
};

export default OurServices;
